import React from 'react';
import './Education.css';
import Zoom from 'react-reveal/Zoom';
import cer1 from '../Images/cer1.jpg'
import cer2 from '../Images/cer2.jpg'
import cer3 from '../Images/cer3.jpg'
import cer4 from '../Images/cer4.jpg'
import cer5 from '../Images/cer5.jpg'
import cer6 from '../Images/cer6.jpg'


const EducationMe = () => {
  return (
    <>
    <Zoom>
    <h1 className='text-center pb-11 text-2xl'>Education</h1>
      <section>

<div className="container ">
    <div className="main-timeline ">


        <div className="timeline ">
            <div className="icon "></div>
            <div className="date-content ">
                <div className="date-outer ">
                    <span className="date ">
                                        <span className="month ">4 Years</span>
                    <span className="year ">2020-24</span>
                    </span>
                </div>
            </div>
            <div className="timeline-content ">
                <h5 className="title ">Bachelor of Technology</h5>
                <p className="description ">
                    I'm a Undergraduate 2nd Year Student currently Undertaking a Bachelors course in Information Technology at Barkatullah University Institute of Technology.
                </p>

            </div>
        </div>
      
        <div className="timeline ">
            <div className="icon "></div>
            <div className="date-content ">
                <div className="date-outer ">
                    <span className="date ">
                                        <span className="month ">2 Years</span>
                    <span className="year ">2018-20</span>
                    </span>
                </div>
            </div>
            <div className="timeline-content ">
                <h5 className="title ">Higher Secondary Education (HSC)</h5>
                <p className="description ">
                    I completed my Higher Secondary Education from Bourbon Higher Secondary School. </p>
            </div>
        </div>
      
        <div className="timeline ">
            <div className="icon "></div>
            <div className="date-content ">
                <div className="date-outer ">
                    <span className="date ">
                                        <span className="month ">2 Years</span>
                    <span className="year ">2016-18</span>
                    </span>
                </div>
            </div>
            <div className="timeline-content ">
                <h5 className="title ">High School (SSC)</h5>
                <p className="description ">
                    I completed my Higher Secondary Education from Bourbon Higher Secondary School. </p>
            </div>
        </div>
       


    </div>
</div>
<br />
<br />
<br />
<br />
<br />
</section>
<h1>Certificates</h1>
<br />
<br />
<ul id="rig">

            <li>
                <a className="rig-cell" href={"material/pdf/cerpdf (2).pdf"}>
                    <img className="rig-img" src={cer2}/>
                    <span className="rig-overlay"></span>
                    <span className="rig-text">React js Bootcamp</span>
                </a>
            </li>
            <li>
                <a className="rig-cell" href="material/pdf/cerpdf (1).pdf">
                    <img className="rig-img" src={cer3}/>
                    <span className="rig-overlay"></span>
                    <span className="rig-text">Appreciation</span>
                </a>
            </li>


            <li>
                <a className="rig-cell" href="material/pdf/cerpdf (6).pdf">
                    <img className="rig-img" src={cer4}/>
                    <span className="rig-overlay"></span>
                    <span className="rig-text">Html, Css and Js Bootcamp</span>
                </a>
            </li>
            <li>
                <a className="rig-cell" href="material/pdf/cerpdf (3).pdf">
                    <img className="rig-img" src={cer5}/>
                    <span className="rig-overlay"></span>
                    <span className="rig-text">Energy Conversation</span>
                </a>
            </li>

            <li>
                <a className="rig-cell" href="material/pdf/cerpdf (5).pdf">
                    <img className="rig-img" src={cer6}/>
                    <span className="rig-overlay"></span>
                    <span className="rig-text">English Aptitude Quiz</span>
                </a>
            </li>
            <li>
                <a className="rig-cell" href="material/pdf/cerpdf (4).pdf">
                    <img className="rig-img" src={cer1}/>
                    <span className="rig-overlay"></span>
                    <span className="rig-text">Science Day</span>
                </a>
            </li>

        </ul>
</Zoom>
<br />
<br />
    </>
  )
}

export default EducationMe